import { Link } from "react-router-dom";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";

export default function NotFound() {
  useDocumentMeta({
    title: "页面不存在 - 吃瓜复盘局",
    description: "你访问的页面不存在或已被移动，可以回到首页或事件库继续浏览网红事件完整经过与深度解析。",
    keywords: "页面不存在,吃瓜复盘局",
    canonical: "https://rbnetwork.cn/",
  });

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background-50 px-4 py-24 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-100 text-foreground-500">
        <i className="ri-emotion-sad-line text-3xl"></i>
      </span>
      <p className="mt-6 font-heading text-5xl font-bold text-primary-500">404</p>
      <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950">
        这里没有你要找的内容
      </h1>
      <p className="mt-3 max-w-md text-sm leading-7 text-foreground-600">
        页面可能已被移动或链接有误。回到首页，或去事件库按分类重新找找看。
      </p>
      <div className="mt-8 flex flex-col gap-3 sm:flex-row">
        <Link
          to="/"
          className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          回到首页
        </Link>
        <Link
          to="/events"
          className="whitespace-nowrap rounded-md border border-background-300 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
        >
          浏览事件库
        </Link>
      </div>
    </div>
  );
}